import axios, { AxiosInstance } from 'axios';
import {
	GetAllGameEnginesOutDTO,
	GetNextChallengeInDTO,
	GetNextChallengeOutDTO,
	GameSessionDTO,
	StartRadomGameInDTO,
	CreateGameInDTO,
	CreateGameOutDTO,
	GetMyGamesQueryDTO,
	GetMyGamesOutDTO,
	GameItemDTO,
	GameEngineItemDTO,

	GetGameResultsOutDTO,
	UpdateGameSettingsInDTO,
	UpdateGameSettingsOutDTO,
	StartGameInDTO,
	StartGameOutDTO,
	GetGameSessionResultDetailsOutDTO,
	GetGameResultsQueryDTO
} from '@haohan/game-dto';
import { FirstAndLastStrokeApi } from './engines/firstAndLastStroke';
import { plainToInstance } from 'class-transformer';
import { DrawMissingGraphemeApi } from './engines/drawMissingGrapheme';
import { StrokesCountApi } from './engines/strokesCount';

type CancelablePromise<T=unknown> = Promise<T> & {
	abort?: () => void
}

export const gameApi = {
	engines: {
		firstAndLastStroke: new FirstAndLastStrokeApi(),
		drawMissingGrapheme: new DrawMissingGraphemeApi(),
		strokesCount: new StrokesCountApi()
	},
	getAllGameEngines(
		http: AxiosInstance = axios
	): CancelablePromise<GetAllGameEnginesOutDTO> {
		const controller = new AbortController();
		const req = http.get<GetAllGameEnginesOutDTO>(
			`/api/game/engines/all/`,
			{signal: controller.signal}
		);
		req['abort'] = controller.abort;
		return req.then(v => v.data);
	},
	async getGameEngine(name: string): Promise<GameEngineItemDTO> {
		const req = await axios.get(`/api/game/engine/get/${name}/`);
		return plainToInstance(GameEngineItemDTO, req.data['engine']);
	},
	async getGameResults(
		gameHash: string,
		params: GetGameResultsQueryDTO
	): Promise<GetGameResultsOutDTO> {
		const req = await axios.get(`/api/game/game/${gameHash}/results`, {params});
		return plainToInstance(GetGameResultsOutDTO, req.data);
	},
	async getMyGames(params?: GetMyGamesQueryDTO): Promise<GetMyGamesOutDTO> {
		const req = await axios.get(`/api/game/game/my/collection/`, {params});
		return plainToInstance(GetMyGamesOutDTO, req.data);
	},
	async createGame(input: CreateGameInDTO): Promise<CreateGameOutDTO> {
		const req = await axios.post<CreateGameOutDTO>(
			`/api/game/game/create/`, input
		);
		return req.data;
	},
	async updateGameSettings(
		input: UpdateGameSettingsInDTO
	): Promise<UpdateGameSettingsOutDTO> {
		const req = await axios.post<UpdateGameSettingsOutDTO>(
			`/api/game/settings/update/`, input
		);
		return req.data;
	},
	async getGame(publicHash: string): Promise<GameItemDTO> {
		const res = await axios.get(`/api/game/game/get/${publicHash}`);
		return res.data['game'];
	},
	async randomGame(input: StartRadomGameInDTO): Promise<GameSessionDTO> {
		const req = await axios.post<GameSessionDTO>(
			`/api/game/random/start/`, input
		);
		return req.data;
	},
	async startGame(input: StartGameInDTO): Promise<GameSessionDTO> {
		const req = await axios.post<StartGameOutDTO>(
			`/api/game/start/`, input
		);
		return req.data.gameSession;
	},
	async getGameSession(sessionId: string): Promise<GameSessionDTO> {
		const req = await axios.get<GameSessionDTO>(
			`/api/game/session/get/${sessionId}`
		);
		return req.data;
	},
	async nextChallenge(
        input: GetNextChallengeInDTO,
    ): Promise<GetNextChallengeOutDTO> {
        const res = await axios.get<GetNextChallengeOutDTO>(
            `/api/game/session/${input.publicHash}/challenge/next`
        );
        return res.data;
    },
	async getGameSessionResultDetails(sessionId: string): Promise<GetGameSessionResultDetailsOutDTO> {
		const req = await axios.get<GetGameSessionResultDetailsOutDTO>(
			`/api/game/session/${sessionId}/result/details`
		);
		return req.data;
	},
	// search(): CancelablePromise<LessonCollectionResultDto> {
	// 	const controller = new AbortController();
	// 	const req = axios.get(
	// 		'/api/lesson/collection/',
	// 		{signal: controller.signal}
	// 	);
	// 	req['abort'] = controller.abort;
	// 	return req.then(v => v.data);
	// }
}